export interface ListBasicType {
    id: string
    isDragDisabled?: boolean
    itemIds: string[]
}

export interface ListType extends ListBasicType {
    footer?: React.ReactNode
    header?: React.ReactNode
    title?: string
}

export interface ItemType {
    id: string
    [key: string]: any
}

export interface ItemProps extends ItemType {
    classNameItem?: string
    events?: {
        onItemClick?: (id: string) => void
        onItemDelete?: (id: string) => void
    }
    Item?: React.ElementType<ItemProps>
    isVisible: boolean
}

export interface OnNewItemClickedArgs {
    listId: string
    data: any
    index: number
}

export type OnItemDeleteArgs = { id: string; listId: string }

export interface State extends DragDropData {
    itemsBasicProps: ItemListBasicType
}

export type ItemListType = { [key: string]: ItemType }
export type ItemListBasicType = {
    [key: string]: { id: string }
}

export interface DragDropData {
    listOrder: string[]
    lists: {
        [key: string]: ListType
    }
    items: ItemListType
    // itemsAllProps: ItemListAllPropsType
    filter: {
        isFiltered: boolean
        visibleItems?: string[]
    }
}

export interface StateBeforeEvent {
    listOrder: string[]
    lists: {
        [key: string]: ListBasicType
    }
    items: ItemListBasicType
}

export enum ServerEventStatus {
    Error = 'error',
    Loading = 'loading',
    Success = 'success'
}

export interface OptimisticLocalState {
    // listOrder: string[]
    event: {
        itemId: ItemId
        type: BoardEvent
        stateBeforeEvent: StateBeforeEvent
        serverEventStatus: ServerEventStatus
    }[]
    // filter: {
    //     isFiltered: boolean
    //     visibleItems?: string[]
    // }
}

type ItemId = string
export enum BoardEvent {
    create = 'create',
    delete = 'delete',
    move = 'move'
}

export interface NewItemArgs {
    id: string
    listId: string
    [key: string]: any
    position: number | ('start' | 'end')
}

export type OnSaveNewItemFunction = (args: OnNewItemClickedArgs) => NewItemArgs

export interface DragDropListsEvents {
    onItemClick?: (id: string) => void
    onItemDelete?: (args: OnItemDeleteArgs) => Promise<any>
    onItemMove?: (args: OnItemMoveArgs) => Promise<any>
    onDataChanged?: (data: DragDropData) => void
    onNewItemAdd?: (args: NewItemArgs) => Promise<any>
}

export type Position = 'start' | 'end'

export interface NewItemButtonProps {
    isDisabled?: boolean
    onNewItemClicked?: (position: Position) => void
    position: Position
    title?: string
}

export type OnItemMoveArgs = {
    id?: string
    targetNodeId: string
    targetId?: string
    targetIndex: number
    sourceId?: string
    sourceIndex: number
    type?: string
}

export const DroppableListType = 'list'
export const DroppableItemType = 'item'
